import React, { useMemo } from "react";
import type { ReactNode } from "react";
import { getAppConfig } from "../../config";
import { ApolloProvider } from "@apollo/client";
import { createClient } from "./client";
import { useAuthSession, AuthTokenRefresher } from "../../hooks";

export function ProvideGraphQL({ children }: { children: ReactNode }) {
    const config = getAppConfig();
    const [, setAuthSession] = useAuthSession(["authToken"]);

    const client = useMemo(
        () =>
            createClient({
                baseURL: config.backendBaseURL,
                onInvalidAuthToken: () => {
                    setAuthSession("authToken", undefined);
                    setAuthSession("me", undefined);
                },
            }),
        [config.backendBaseURL, setAuthSession]
    );

    return (
        <ApolloProvider client={client}>
            <>
                <AuthTokenRefresher />
                {children}
            </>
        </ApolloProvider>
    );
}
